import { Grid, Tooltip } from "@material-ui/core";
import { getDateTime, hideMiddleDigits } from "app/common/LocalFunction";
import { useStore } from "app/stores";
import { observer } from "mobx-react";
import React, { memo, useEffect } from "react";
const ListSalesInteraction = ({ initialPatient }) => {
  const { getDataLeadReaction, dataLeadReaction } =
    useStore().patientManagementStore.patientGeneralStore;

  useEffect(() => {
    const phoneNumber = initialPatient?.patientInfo?.phoneNumber;
    if (phoneNumber) {
      getDataLeadReaction();
    }
  }, [initialPatient?.patientInfo?.phoneNumber]);
  return (
    <div
      style={{
        backgroundColor: "aliceblue",
        height: "100%",
        boxShadow: "0 8px 24px rgba(0, 0, 0, 0.08)",
      }}
    >
      <Grid
        container
        spacing={1}
        className="m-0 w-100"
        style={{ backgroundColor: "aliceblue" }}
      >
        <Grid item xs={12} className="search-title-card">
          <p className="title-block">Tương tác của Sale</p>
        </Grid>

        <Grid item xs={12}>
          <div
            style={{
              maxHeight: "400px",
              overflowY: "auto",
              paddingRight: 8,
            }}
            className="custom-scrollbar"
          >
            {(dataLeadReaction?.content || []).map((item, index) => (
              <div class="notes-box">
                <div class="note-item">
                  <div class="note-header">
                    <span
                      className="note-date"
                      style={{ fontSize: "var(--fs-base-two)" }}
                    >
                      {getDateTime(item?.reactionTime)}
                    </span>

                    {/* <span 
                        class="note-tag" 
                        style={{ 
                            fontSize: "var(--fs-base-two)", 
                            background: "#eaf3f9", 
                            color: "#6494bd", 
                            padding: "2px 6px", 
                            borderRadius: "6px",
                            marginLeft: "8px",
                            width:"82px"
                        }}
                    >
                        {item?.reactionStatus?.name}
                    </span> */}
                    <span
                      class="note-user"
                      style={{
                        fontSize: "var(--fs-base-two)",
                        color: "#3d6e94",
                        marginLeft: "8px",
                      }}
                    >
                      👤 {item?.agent?.name}
                    </span>
                  </div>
                  <div class="note-content">
                    <span style={{ fontSize: "13px" }}>
                      Trạng thái: {item?.reactionStatus?.name}
                    </span>
                    <span style={{ fontSize: "13px" }}>
                      | Nguồn: {item?.lead?.leadSource?.name}
                    </span>
                  </div>
                  <div class="note-content">
                    <span style={{ fontSize: "13px" }}>
                      <span style={{ marginRight: "6px", color: "#6494bd" }}>
                        📇
                      </span>
                      <b style={{ color: "#6494bd" }}>
                        {item?.lead?.fullName || ""}
                      </b>
                      <span style={{ color: "#666", marginLeft: "6px" }}>
                        - {item?.lead?.code || ""}
                      </span>

                      {item?.lead?.leadType && (
                        <span style={{ color: "#666", marginLeft: "6px" }}>
                          - {item?.lead?.leadType?.name || ""}
                        </span>
                      )}
                    </span>
                  </div>
                  {item?.phoneNumber && (
                    <div class="note-content">
                      <span style={{ fontSize: "13px", color: "#444" }}>
                      SĐT: {hideMiddleDigits(item?.phoneNumber) || ""}
                      </span>
                    </div>
                  )}
                  <div class="note-content">
                    <span style={{ fontSize: "13px", color: "#444" }}>
                      {item?.content || ""}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default memo(observer(ListSalesInteraction));
